module.exports = __webpack_public_path__ + "img/melissa-clientes.c731b24a.png";